import React from "react";

const NoResults = () => {
  // TODO: Add no results
  return (
    <div className="ft_dealer-locator__no-results">
      No Results
    </div>
  );

}

export default NoResults;
